import { render, staticRenderFns } from "./forget_password.vue?vue&type=template&id=04455064&scoped=true"
import script from "./forget_password.vue?vue&type=script&lang=js"
export * from "./forget_password.vue?vue&type=script&lang=js"
import style0 from "./forget_password.vue?vue&type=style&index=0&id=04455064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04455064",
  null
  
)

export default component.exports